// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2zQ-W","content":"styles_content__3uTF7","checkbox":"styles_checkbox__1Eceh","checkboxLabel":"styles_checkboxLabel__3iwiG"};